import {Navigate, useLocation} from 'react-router-dom';
import {IRouterValidateProps} from '@/types';
import {PageRoute, STORAGE_KEYS} from '@/constants';

const RequireAuth = ({children}: IRouterValidateProps) => {
  const location = useLocation();
  const isAuthenticated = !!localStorage.getItem(STORAGE_KEYS.USER_ACCESS_TOKEN);

  if (!isAuthenticated) {
    return <Navigate to={PageRoute.LOGIN} state={{from: location}} />;
  } else {
    return children;
  }
};

export default RequireAuth;
